export default __webpack_public_path__ + "static/media/Group.63873454.svg";